module.exports = __webpack_public_path__ + "static/img/active-ingr-yes-01.cee8dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/active-ingr-yes-01.jpg
// module id = 245
// module chunks = 1